module.exports = __webpack_public_path__ + "static/listoscalifornia-e386f34acffa327d1d17c50d0cadfc36.jpg";